module.exports = __webpack_public_path__ + "img/countbg1.20bb8893.png";